export default __webpack_public_path__ + "static/media/team7.1543f612.png";